import { Sticky, StickyContainer } from 'react-sticky';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useQuery from '../../../util/useQuery';
import TabDetail from './TabDetail';
import { Tabs } from 'antd';
import { ROUTER } from '../../../constants/router';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);

export default function TabsDetail({ riskInfoTabs, riskInfo }) {
    const { riskId, menu } = useParams();
    const navigate = useNavigate();
    const params = useQuery();

    const location = useLocation();
    const mode = location?.state?.mode;
    const activityId = location?.state?.activityId;

    const riskRegisterTopics = riskInfoTabs?.riskRegisterTopics?.filter(
        (r) => r.riskRegisterOptions?.length > 0
    );

    return (
        <>
            <div className="bg-white h-max rounded-xl p-4 py-6 my-4">
                <StickyContainer>
                    <Tabs
                        className="tabs"
                        onChange={(key) => {
                            const path =
                                menu !== 'ra'
                                    ? `${ROUTER.RISK_MANAGEMENT.RR}/${riskId}`
                                    : `${ROUTER.RISK_MANAGEMENT.RA}/ra/risk-register/${riskId}`;
                            return navigate(`${path}?tab=${key}`, {
                                state: { mode, activityId },
                            });
                        }}
                        activeKey={params.get('tab') || '0'}
                        renderTabBar={renderTabBar}
                    >
                        {riskRegisterTopics?.map((riskTopic, i) => (
                            <TabPane
                                tab={
                                    riskTopic.riskRegisterTopicTitle
                                        ? riskTopic.riskRegisterTopicTitle
                                        : '-'
                                }
                                key={i}
                            >
                                <h1
                                    className="text-xl font-bold pt-4"
                                    style={{
                                        borderTop: '3px solid #F4F6FC',
                                    }}
                                >
                                    {riskTopic.riskRegisterTopicName
                                        ? riskTopic.riskRegisterTopicName
                                        : '-'}
                                </h1>
                                <p>
                                    {riskTopic.riskRegisterTopicDesc
                                        ? riskTopic.riskRegisterTopicDesc
                                        : '-'}
                                </p>
                            </TabPane>
                        ))}
                    </Tabs>
                </StickyContainer>
            </div>
            {riskRegisterTopics && (
                <TabDetail
                    riskInfo={riskInfo}
                    riskRegisterOptions={
                        riskRegisterTopics[params.get('tab') || 0]
                            .riskRegisterOptions
                    }
                />
            )}
        </>
    );
}
